import { useMemo }           from 'react';
import { GridValidRowModel } from '@mui/x-data-grid-pro';

import { Modal }            from '@shared/components/modals/Modal';
import { GridColTextInput } from '@shared/components/grid/GridColTextInput';
import { newGridRecordId }  from '@shared/commonFunctions';
import { dataGridCol }      from '@shared/components/grid/common';
import { PhoenixGrid }      from '@shared/components/grid/PhoenixGrid';

import {
  requestCreateEmailConfig,
  requestDeleteEmailConfig,
  requestUpdateEmailConfig
}                                             from '../requests';
import { useConfigureEmailsValidationSchema } from '../validation';
import { IEmail }                             from '../types';

const columns = [
  dataGridCol('email', {
    headerName     : 'Configured Emails',
    minWidth       : 200,
    flex           : 1,
    editable       : true,
    renderEditCell : (params) => <GridColTextInput params={params} />,
  }),
];

interface IConfigureEmailsModalProps {
  emails? : IEmail[];
  error   : boolean;
  confiqureEmailModalPosition: number;
  mutate  : () => void;
  onClose : () => void;
}

export const ConfigureEmailsModal = ({ onClose, emails, error, confiqureEmailModalPosition, mutate }: IConfigureEmailsModalProps) => {
  const configureEmailsValidationSchema = useConfigureEmailsValidationSchema((emails || []).map((email) => email.email));

  const actions = useMemo(() => ({
    onSave: async({ id, email }: GridValidRowModel) => {
      let response = null;
      if (id === newGridRecordId) {
        response =  await requestCreateEmailConfig(email);
      } else {
        response = await requestUpdateEmailConfig(id, email);
      }

      if (!response?.error) {
        mutate();
      }
      return response;
    },
    onDelete: async({ id }: GridValidRowModel) => {
      await requestDeleteEmailConfig(id);
      mutate();
    },
  }), [requestDeleteEmailConfig, requestCreateEmailConfig, requestUpdateEmailConfig, mutate]);

  return (
    <Modal 
      open
      hideBackdrop
      resetPosition={confiqureEmailModalPosition}
      title="Configure Email"
      dialogWidth="700px" 
      onClose={onClose}
    >
      <PhoenixGrid
        withHeader
        canNotCopy
        strict
        height         = "500px"
        loading        = {!emails && !error}
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        actions        = {actions}
        columns        = {columns}
        validateSchema = {configureEmailsValidationSchema}
        rows           = {emails || []}
      />
    </Modal>
  );
};
